import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import { useLanguage } from '../../i18n/LanguageContext';

function SellerButtons({ onTogglePrompt, showPrompt, onDelete, dataId, isPublished, onPublishToggle, hidePublishButton = false }) {
  // Retrieve the user type from localStorage (or from your context/state management)
  const userType = localStorage.getItem('userType');
  const { t } = useLanguage();

  const handlePublishToggle = async () => {
    try {
      const response = await axios.post(
        `/api/toggle-published/${dataId}`,
        {},
        { 
          withCredentials: true,
          baseURL: config.backend_url
        }
      );
      
      if (response.status === 200) {
        // Call the callback to update the UI
        if (onPublishToggle) {
          onPublishToggle(response.data.is_published);
        }
      }
    } catch (error) {
      console.error('Error toggling publication status:', error);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="home-button" style={{ marginRight: '10px' }}>
        <Link to="/">
          <button>{t('common.home')}</button>
        </Link>
      </div>
      
      {/* Only display these buttons if the logged-in user is a seller */}
      {userType === 'seller' && (
        <>
          <button
            onClick={onDelete}
            className="delete-button-sellerdata"
            style={{ marginRight: '10px' }}
          >
            {t('smallWidgets.delete')}
          </button>
          
          {/* New publish/unpublish toggle button - only show if not hidden */}
          {!hidePublishButton && (
            <button
              onClick={handlePublishToggle}
              className={`publish-button ${isPublished ? 'unpublish' : 'publish'}`}
              style={{ 
                marginRight: '10px',
                backgroundColor: isPublished ? '#ffaa00' : '#4CAF50',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              {isPublished ? t('ad.unpublish') : t('ad.publish')}
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default SellerButtons;
